module.exports = __webpack_public_path__ + "static/media/kg.c6895000.svg";